import { enUS } from '../translations/en-US'

type MessageKey = keyof typeof enUS
type Messages = Record<MessageKey | string, string>

export const messages: Record<string, Messages> = {
  en: enUS,
  'en-US': enUS
}
